var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAuditLog = function SvgAuditLog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#audit-log_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 7H1a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1M4 3H2v2h2zm.414 9 1.293 1.293.025.025a1 1 0 1 1-1.44 1.389L3 13.414l-1.293 1.293-.025.025a1 1 0 0 1-1.39-1.44L1.587 12 .293 10.707l-.025-.025a1 1 0 0 1 1.439-1.39L3 10.587l1.293-1.293a1 1 0 0 1 1.414 1.414zM15 3H9a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2m-6 8h6a1 1 0 0 1 0 2H9a1 1 0 0 1 0-2",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "audit-log_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgAuditLog;